'use client';

import { css } from '@linaria/core';

export const viewport = css``;

export const right = css`
  > * {
    transform: translateX(50%);
  }
  &.${viewport} {
    > * {
      transform: translateX(0%);
    }
  }
`;

export const left = css`
  > * {
    transform: translateX(-50%);
  }
  &.${viewport} {
    > * {
      transform: translateX(0%);
    }
  }
`;

export const grow = css`
  > * {
    transform: scale(0.8);
  }
  &.${viewport} {
    > * {
      transform: scale(1);
    }
  }
`;

export const root = css`
  overflow: hidden;
  > * {
    opacity: 0;
    transition: all 0.5s ease-in;
  }
  &.${viewport} {
    overflow: visible;
    > * {
      opacity: 1;
    }
  }
`;
